module.exports = __webpack_public_path__ + "img/point-6.97a007fa.png";